import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-btn-nuevo-forma-pago',
  templateUrl: './btn-nuevo-forma-pago.component.html',
  styleUrls: ['./btn-nuevo-forma-pago.component.css']
})
export class BtnNuevoFormaPagoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
